import { Object3D, PerspectiveCamera, Scene } from 'three';

import { Background } from './Background';

// Background Scene: Used when needed to render
// only background (TwitterConnect page for example).
export class BackgroundScene extends Object3D {
    background: Background;
    camera: PerspectiveCamera;
    scene: Scene;

    constructor() {
        super();

        this.background = new Background();
        this.camera = new PerspectiveCamera(30, window.innerWidth / window.innerHeight, 0.2, 1000);

        this.scene = new Scene();
        this.scene.add(this);
        this.scene.add(this.background);

        this.visible = false;
    }

    setSize(width: number, height: number) {
        this.camera.aspect = width / height;
        this.camera.updateProjectionMatrix();

        this.background.setSize(width, height);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    update(delta: any) {
        this.background.update(delta);
    }
}
